import { useState, useEffect, createContext, useContext } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useWebsite } from 'providers/WebsiteProvider';

export const AuthContext = createContext(null);

export const useAuth = () => {
	return useContext(AuthContext);
};

export default function AuthProvider(props) {
	const [authChecked, setAuthChecked] = useState(false);
	const [token, setToken] = useState(null);
	const [userData, setUserData] = useState(null);
	const { setProfileOpen } = useWebsite();
	const navigate = useNavigate();

	// Check for stored token on mount
	useEffect(() => {
		const storedToken = localStorage.getItem('FD_TOKEN');
		if (storedToken) {
			console.log('Stored token found:', storedToken);
			setToken(storedToken);
		} else {
			console.log('No token stored');
			setAuthChecked(true);
		}
	}, []);

	// Handle token changes
	useEffect(() => {
		console.log('Token changed:', token);
		if (token) {
			localStorage.setItem('FD_TOKEN', token);
			console.log('Checking session...');
			getUserData();
		} else {
			localStorage.removeItem('FD_TOKEN');
			setUserData(null);
		}
	}, [token]);

	useEffect(() => {
		setAuthChecked(true);
	}, [userData]);

	const login = (email, password, onStart, onError) => {
		if (onStart) onStart();

		const url = global.backingsEndpoint + 'userLogin/loginToken';
		const body = { email, password };

		return axios.post(url, body)
			.then(response => {
				if (response.data) {
					setToken(response.data);
				} else if (onError) {
					onError();
				}
			})
			.catch(error => {
				console.error('Login error:', error);
				if (onError) onError();
			});
	};

	const getUserData = (cb) => {
		if (!token) return;

		const url = global.backingsEndpoint + 'accessManagement/getLoggedInClientDto';

		axios.post(url)
			.then(response => {
				if (response.data && Object.keys(response.data).length > 0) {
					extendUserData(response.data, cb);
				} else {
					logoutBySessionExpired(cb);
				}
			})
			.catch(error => {
				console.error('Get user data error:', error);
				logoutBySessionExpired(cb);
			});
	};

	function extendUserData(userData, cb) {
		console.log('Extend user data.')
		const url = global.backingsEndpoint + 'employeeUserControl/getUserVIPDataFromHUMUSZ';

		axios.post(url).then(function (response) {
			setUserData(Object.assign(response.data, userData));
			console.log('Done.');
			if (cb) cb();
		}).catch(function (error) {
			console.log(error);
			logoutBySessionExpired(cb);
		});
	};

	const logout = () => {
		setToken(null);
		localStorage.removeItem('FD_TOKEN');
		setUserData(null);
		setProfileOpen(false);
		setAuthChecked(true);
		navigate('/');
	};

	const logoutBySessionExpired = (cb) => {
		console.log('SESSION EXPIRED');
		setToken(null);
		localStorage.removeItem('FD_TOKEN');
		setUserData(null);
		setProfileOpen(false);
		setAuthChecked(true);
		cb?.();
		navigate('/bejelentkezes');
	};

	function refreshUserData(cb) {
		getUserData(cb);
	};

	function modifyUserDataValue(key, value) {
		setUserData((currentUserData) => currentUserData
			? { ...currentUserData, [key]: value }
			: currentUserData
		);
	};

	const value = {
		authChecked,
		token,
		userData,
		login,
		logout,
		getUserData,
		refreshUserData,
		modifyUserDataValue
	};

	return <AuthContext.Provider value={value}>{props.children}</AuthContext.Provider>;
}
